import React from 'react'

function Back() {
  return (
    <div className='back'>
        <div>HiggsTypingは移行しました。</div>
        <div>プレイしたことのある方はIDをコピーして以下のリンクへ飛んで、ログインから引き継いでください。</div>
        <div>
            <div>ID: {localStorage.getItem("screen_name")}</div>
            移行先 <a href='https://higgs.boson.jp'>https://higgs.boson.jp</a>
        </div>
    </div>
  )
}

export default Back